<template>
    <div v-if="pending" class="text-center" style="transition: none !important;">
        <b-spinner/>
    </div>

    <main v-else>
        <header class="justify-between align-items-stretch mb-3">
            <b-breadcrumb class="flex-grow-1 mb-0">
                <b-breadcrumb-item :to="{ name: 'addresses.index' }">
                    {{ $t('Addresses') }}
                </b-breadcrumb-item>

                <b-breadcrumb-item active>
                    {{ id ? [address.first_name, address.last_name,
                    address.organization].join(' ') : $t('Create') }}
                </b-breadcrumb-item>
            </b-breadcrumb>

            <b-dropdown
                v-if="id"
                :id="'address_actions_dropdown_' + address.id"
                :title="$t('Actions')"
                class="ml-3"
                right
                no-caret
            >
                <template slot="button-content">
                    <fa icon="ellipsis-v" fixed-width/>
                </template>

                <b-dropdown-item variant="danger" @click="handleDelete">
                    <fa icon="trash" fixed-width/>
                    {{ $t('Delete') }}
                </b-dropdown-item>
            </b-dropdown>
        </header>

        <b-form-group
            :label="$t('Internet search')"
            label-for="search"
        >
            <address-search
                :placeholder="$t('Type to search')"
                @input="fillFields"
            />
        </b-form-group>

        <b-card class="mb-3" no-body tag="section">
            <address-form
                ref="addressForm"
                :value="address"
            />
        </b-card>
    </main>
</template>

<script>
    import AddressSearch from "@/components/selects/AddressSearch";
    import AddressForm from "@/components/addresses/AddressForm";
    import itemMixin from "@/mixins/itemMixin";

    export default {
        name: 'BauplanAddress',
        components: {AddressForm, AddressSearch},
        mixins: [itemMixin],
        data() {
            return {
                pending: false,
                address: {
                    label: null,
                    city: null,
                    country_code: null,
                    street: null,
                    postal_code: null,
                    latitude: null,
                    longitude: null
                }
            };
        },
        computed: {
            resourceName() {
                return 'addresses';
            }
        },
        methods: {
            fillFields(address) {
              this.$refs.addressForm.fillFields(Dddress);
            },

            setData(data) {
                this.address = Object.assign({}, {
                    label: null,
                    city: null,
                    country_code: null,
                    street: null,
                    postal_code: null,
                    latitude: null,
                    longitude: null
                }, data);
            },
        },
    };
</script>
